import type { AccountingSession } from './api/accountingDirectoryApi';

export const ACCOUNTING_APPLICATION_PROFILE = Object.freeze({ id: 'edgelex_us_usd_core_provisional.v1',
  digest: '0febece440747d6c81322d50c6470e28f865c08c861ba3de8ac282a6620e4e0c' });
export const accountingUiEnabled = (value: string | undefined = import.meta.env.VITE_EDGELEX_ACCOUNTING): boolean => value === 'true';
export const accountingCoreBooksEnabled = (value: string | undefined = import.meta.env.VITE_EDGELEX_ACCOUNTING_CORE_BOOKS): boolean => value === 'true';
export const accountingInvoicesEnabled = (value: string | undefined = import.meta.env.VITE_EDGELEX_ACCOUNTING_INVOICES): boolean => value === 'true';
export interface AccountingKeycloakSession {
  authenticated?: boolean; realm?: string; subject?: string; sessionId?: string;
  tokenParsed?: { iss?: unknown; sub?: unknown; sid?: unknown; session_state?: unknown };
}
/** These are session invalidation hints only. The server directory resolves and verifies all financial authority. */
export function accountingKeycloakSession(keycloak: AccountingKeycloakSession): AccountingSession | null {
  try {
    const { realm, subject, tokenParsed: claims } = keycloak;
    if (!keycloak.authenticated || !realm || !/^[A-Za-z0-9._-]{1,128}$/.test(realm) || !subject || subject.trim() !== subject
      || claims?.sub !== subject || typeof claims.iss !== 'string') return null;
    const issuer = new URL(claims.iss);
    if (issuer.protocol !== 'https:' || issuer.username || issuer.password || issuer.search || issuer.hash || !claims.iss.endsWith('/realms/' + realm)) return null;
    const epoch = claims.sid ?? claims.session_state ?? keycloak.sessionId;
    if (typeof epoch !== 'string' || !epoch || epoch.trim() !== epoch || epoch.length > 2000) return null;
    return { realmId: realm, issuer: claims.iss, subject, sessionEpoch: epoch };
  } catch { return null; }
}
